import React from 'react';

/**
 * Renders a paragraph item which can be:
 *  - string -> plain text
 *  - { html: "..." } -> sanitized HTML
 *  - { list: [...] } -> bullet list
 *  - { sub: "...", body: "..." } -> sub-section with title
 */
export default function LegalRenderer({ content }) {
  if (!content) return null;
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-12 py-16 lg:py-24" data-testid="legal-page">
      <p className="gn-overline mb-4">{content.label}</p>
      <h1 className="font-serif text-4xl md:text-5xl text-[#f5f5f0] mb-10">{content.title}</h1>

      <div className="space-y-8 text-[#a3b5ad] font-light leading-relaxed text-base">
        <p className="text-xs uppercase tracking-[0.2em] text-[#c9a961]">{content.lastUpdate}</p>

        {content.sections.map((sec, i) => (
          <section key={i} className="space-y-3">
            <h2 className="font-serif text-2xl text-[#f5f5f0]">{sec.h}</h2>
            {sec.paragraphs.map((p, j) => {
              if (typeof p === 'string') return <p key={j}>{p}</p>;
              if (p.html) return <p key={j} dangerouslySetInnerHTML={{ __html: p.html }} />;
              if (p.list) return (
                <ul key={j} className="list-disc list-inside space-y-1 pl-4">
                  {p.list.map((li, k) => <li key={k}>{li}</li>)}
                </ul>
              );
              if (p.sub) return (
                <div key={j} className="border-l-2 border-[#c9a961]/40 pl-5 space-y-2">
                  <h3 className="font-serif text-lg text-[#f5f5f0]">{p.sub}</h3>
                  <p className="text-sm">{p.body}</p>
                </div>
              );
              return null;
            })}
          </section>
        ))}
      </div>
    </div>
  );
}
